var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('view-section-card', {
    staticClass: "fill-height",
    attrs: {
      "title": "태그입력"
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function () {
        return [_c('v-btn-toggle', {
          attrs: {
            "mandatory": "",
            "dense": "",
            "group": "",
            "color": "primary"
          },
          model: {
            value: _vm.mode,
            callback: function ($$v) {
              _vm.mode = $$v;
            },
            expression: "mode"
          }
        }, [_c('v-btn', {
          staticClass: "text-none my-0",
          attrs: {
            "value": "text",
            "text": "",
            "small": ""
          }
        }, [_vm._v("텍스트")]), _c('v-btn', {
          staticClass: "text-none my-0",
          attrs: {
            "value": "list",
            "text": "",
            "small": ""
          }
        }, [_vm._v("리스트")])], 1)];
      },
      proxy: true
    }])
  }, [_vm.mode == 'list' ? [_c('tags-list', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.items,
      callback: function ($$v) {
        _vm.items = $$v;
      },
      expression: "items"
    }
  })] : _vm._e(), _vm.mode == 'text' ? [_c('tags-text', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.items,
      callback: function ($$v) {
        _vm.items = $$v;
      },
      expression: "items"
    }
  })] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }